import {
  UI_SET_ACTIVE_SECTION,
  UI_SET_ACTIVE_TITLE,
  UI_SET_FULLHEIGHT,
  UI_SET_MENU_OPEN,
  UI_SET_SHARE_WIDGET_OPEN,
  UI_SET_FRAME_CONTEXT,
  UI_START_ROUTE_TRANSITION,
  UI_END_ROUTE_TRANSITION,
} from '../actions/uiActions';


export const ui = (state = {
  fullHeight: true,
  menuIsOpen: false,
  activeSection: null,
  isEmbedded: 'no',
  parentUrl: '',
  embeddedUrl: '',
  routeTransitionsRunning: 0,
}, action) => {
  switch (action.type) {
    case UI_SET_ACTIVE_SECTION:
      return { ...state, activeSection: action.payload };
    case UI_SET_ACTIVE_TITLE:
      return { ...state, activeTitle: action.payload };
    case UI_SET_FULLHEIGHT:
      return { ...state, fullHeight: action.payload };
    case UI_SET_MENU_OPEN:
      return { ...state, menuIsOpen: action.payload };
    case UI_SET_SHARE_WIDGET_OPEN:
      return { ...state, shareWidgetIsOpen: action.payload };
    case UI_SET_FRAME_CONTEXT:
      return { ...state, ...action.payload };
    case UI_START_ROUTE_TRANSITION:
      return {
        ...state,
        routeTransitionsRunning: state.routeTransitionsRunning + 1,
      };
    case UI_END_ROUTE_TRANSITION:
      return {
        ...state,
        routeTransitionsRunning: state.routeTransitionsRunning - 1,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/uiReducer.js